<template>
  <div class="tnc-wrapper">
    <h2><span style="font-size: 16pt">條款及條件</span></h2>

    <h4>
      <strong><span style="font-size: 12pt">基本規則</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p><span style="font-size: 10.5pt">我們的網站僅限於達到個人居住司法管轄區規定的法定年齡的個人。</span></p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">我們的網站對任何使用者使用我們網站所侵犯的任何國家法律、聯邦法律或國際法律不承擔任何責任。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">使用者應對自己的行為負責，並受其所在國家法律（包括州法律或法律問題）的約束。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p><span style="font-size: 10.5pt">所有代理商均對其各自會員的帳戶負責，並尊重其提交的所有已確認投注。</span></p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">代理商不是我們網站的合作夥伴。因此，我們的網站對玩家和經紀人之間的任何差異或爭議不承擔任何責任。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">使用者有責任保護其使用者名稱和密碼免於未經授權的使用。如果使用者名稱和密碼被盜或洩露，使用者有責任立即聯繫其代理人。代理將為他/她更改使用者的使用者名稱和密碼。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">如果使用者名稱和密碼被盜，使用者對其各自的帳戶負責，並將兌現所有提交的已確認投注。</span>
        </p>
      </li>
    </ol>

    <h4>
      <strong><span style="font-size: 12pt">遊戲規則</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p><span style="font-size: 10.5pt">我們網站決定的比賽結果將是最終的並具有約束力。</span></p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">在所有爭議情況下，我們網站的管理人員和玩家都必須同意我們的網站交易日誌資料庫將作為爭議的最終仲裁者。所有爭議必須在比賽結果確定之日內提出，比賽日後，任何索賠均不予受理。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p><span style="font-size: 10.5pt">玩家全權負責驗證其所有帳戶交易的準確性。</span></p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">在透過電腦提交投注之前，請務必檢查您的投注是否有任何錯誤、遺漏或疏失。一旦透過電腦接受投注，即無法更改或取消。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">我們保留凍結或取消任何違反本條款和條件、參與詐欺活動、侵入、攻擊、偽造、破壞標準規則或參與集團投注的客戶帳戶的權利，所有由此產生的帳戶餘額將被凍結和沒收，恕不另行通知。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">我們保留作廢或取消任何被發現涉及集團投注、協同投注、串通、欺詐、系統濫用、利用技術錯誤、錯誤賠率，或任何其他試圖取得不公平優勢的投注或注單的權利。任何相關贏款均可能被撤銷，相關帳戶亦可能被暫停或關閉。</span>
        </p>
      </li>
    </ol>

    <h4>
      <strong><span style="font-size: 12pt">限制和責任</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">在不損害前述規定的一般性的情況下，如發生破壞、不可抗力、中央電腦系統或記錄故障、損壞或毀壞，或因電信或數據傳輸系統失效造成的延遲、損失、錯誤或遺漏，以及導致未收到比賽參賽作品之情況，我們網站將不對任何人承擔責任。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">我們的網站不會對因不可抗力、敵對行動爆發、騷亂、內亂、恐怖行為、政府或當局行為（包括拒絕或撤銷任何許可或同意）、火災爆炸、洪水、盜竊、惡意破壞、罷工、停工或任何形式的工業行動造成的損失承擔責任。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span
            style="font-size: 10.5pt">若因網絡連線、通訊、系統或人為錯誤導致投注問題，例如雙倍投注、投注未確認、比賽開始後投注等，我們保留根據具體狀況處理及採取必要措施糾正錯誤的權利。我們對此類錯誤不承擔任何責任。如果您未回報錯誤並繼續投注，若錯誤再次發生，您將承擔所有輸贏結果。</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p><span style="font-size: 10.5pt">這些規則和條例構成雙方之間的完整協議和諒解。</span></p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">若本規則和條例的英文版本與任何其他語言版本有差異，以英文版本為準並視為正確且有效。</span>
        </p>
      </li>
    </ol>

    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
  import BurgerMenu from '@/components/burger-menu.vue';
  import { isMobile } from 'mobile-device-detect';
  export default {
    components: {
      BurgerMenu,
    },
    data: () => {
      return {
        isMobile,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .tnc-wrapper {
    padding: 16px 24px;
    box-sizing: border-box;
    height: calc(100% - 56px);
    overflow-y: auto;
  }

  strong,
  h2,
  h4 {
    font-weight: 600;
  }
</style>
